"use client";

import { FeedbackLink } from "@/components/FeedbackLink";

/** "Report a problem with this listing" — the only feedback surface on a job page. */
export function ReportIssueLink({
  jobId,
  orgKey,
  jobTitle,
  jobUrl,
}: {
  jobId: number;
  orgKey: string;
  jobTitle: string;
  jobUrl: string;
}) {
  return (
    <FeedbackLink
      kind="job_issue"
      prompt="Report a problem with this listing"
      placeholder="What's wrong? (e.g. dead apply link, already filled, wrong details)"
      context={`Job #${jobId} (${orgKey}) — ${jobTitle}\n${jobUrl}`}
      // Default FeedbackLink styling (text-neutral-400, no underline until
      // hover) at the page's text-[11px] wrapper made this the lowest-
      // contrast link on the job page. 0 job_issue feedback_opened events in
      // 30 days on a page type that gets hundreds of views/week — matched the
      // neighbouring "official careers portal" link's own contrast
      // (text-neutral-500, underline) instead of inventing a new style.
      className="text-neutral-500 underline underline-offset-2 hover:text-brand-700"
    />
  );
}
